import { apiCall } from './api';
import type { Enrollment, EnrollTeamRequest, PlaceEnrollmentRequest } from '@sulis-liiga/common';
import { API_ROUTES } from '@sulis-liiga/common';

const enrollmentService = {
  /**
   * Enroll a team into a league/season/division-ladder.
   */
  enrollTeam: async (teamId: string, req: EnrollTeamRequest): Promise<Enrollment> => {
    return apiCall<Enrollment>('post', API_ROUTES.TEAM.ENROLLMENTS(teamId), req);
  },

  /**
   * Get all enrollments for a team.
   */
  getTeamEnrollments: async (teamId: string): Promise<Enrollment[]> => {
    return apiCall<Enrollment[]>('get', API_ROUTES.TEAM.ENROLLMENTS(teamId));
  },

  /**
   * Withdraw an enrollment (team captain or admin).
   */
  withdrawEnrollment: async (enrollmentId: string): Promise<void> => {
    return apiCall<void>('delete', API_ROUTES.ENROLLMENT.WITHDRAW(enrollmentId));
  },

  /**
   * Place an enrollment into a specific division tier (admin only).
   */
  placeEnrollment: async (
    enrollmentId: string,
    req: PlaceEnrollmentRequest,
  ): Promise<Enrollment> => {
    return apiCall<Enrollment>('put', API_ROUTES.ENROLLMENT.PLACE(enrollmentId), req);
  },

  /**
   * Fetch enrollments for a season (admin only). Optionally filter by status.
   */
  getSeasonEnrollments: async (
    leagueId: string,
    seasonId: string,
    status?: string,
  ): Promise<Enrollment[]> => {
    const base = API_ROUTES.LEAGUE.SEASON_ENROLLMENTS(leagueId, seasonId);
    const url = status ? `${base}?status=${encodeURIComponent(status)}` : base;
    return apiCall<Enrollment[]>('get', url);
  },
};

export default enrollmentService;
